<template v-slot:append-outer>
  <custom-tooltip class='tool-tip-hint' placement="right" popper-class="light-tooltip">
    <div slot='buttonContent'>
      <div @click='downloadReport'>
        <div class="report-action-table-cell">
          <div class='report-action-table-cell__btn' @mouseenter='editMouseEnter'>
            <lottie-animation
              class='edit-animation'
              ref="editAnimation"
              :loop='true'
              :animationData="require(this.item.type === 'Cloud Compliance'? '@/assets/icons/animations/document-csv.json' : '@/assets/icons/animations/document-pdf.json')"
              @loopComplete="loopComplete"
            />
          </div>
        </div>
      </div>
    </div>
    <div slot="content">
      <slot name="tooltip">
        <span class='tooltip-text'>{{ $t('reports.layout.download.tooltip.title') }}</span>
      </slot>
    </div>
  </custom-tooltip>
</template>
<script>
import LottieAnimation from 'lottie-web-vue';
import { getFileUrl } from '@/amplify/auth';
import { REPORT_TYPES } from '@/constants/report';
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'ReportIconTableCell',
  components: {
    LottieAnimation,
    CustomTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  methods: {
    editMouseEnter() {
      this.$refs.editAnimation.play();
    },
    loopComplete() {
      this.$refs.editAnimation.pause();
    },
    async downloadReport() {
      const url = await getFileUrl(this.item.link);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      if (this.item.type === REPORT_TYPES.HIGHLIGHT) {
        link.setAttribute('download', `highlight-report-${this.item.tld}-${this.item.date}.pdf`);
      } else {
        link.setAttribute('download', `cyber-risk-report-${this.item.tld}-${this.item.date}.pdf`);
      }
      document.body.appendChild(link);
      link.click();
    },
  },
  computed: {
    icon() {
      return this.item[this.column.name];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/variables";
.report-action-table-cell {
  display: flex;
  align-items: center;
  &__btn {
    z-index: 10;
    margin-top: 8px;
    margin-left: 7px;
    cursor: pointer;
    height: 40px;
    width: 40px;
    min-width: 40px;
    min-height: 40px;
    color: $default-fill-color !important;
    &:hover {
      cursor: pointer;
    }
    .edit-animation{
      height: 40px;
      width: 40px;
      // force lottie SVG to respect container size
      :deep(svg) {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
}

</style>
